import React from "react";
import { Container } from "reactstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link as RouterLink } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper';
import { getPayloadMedia } from "../../services/payloadService";
import parseHtml from "../../utils/parseHtml";
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";

SwiperCore.use([Autoplay, Navigation, Pagination]);

export default function HeroSection({ data, configuracion }) {
    const { slides, blockType, __component } = data;
    const ancla = blockType || __component?.split('.')[1] || 'hero';

    if (!slides || slides.length === 0) return null;

    return (
        <section className="swiper-slider-hero position-relative d-block vh-100" id={ancla}>
            <Swiper
                spaceBetween={0}
                slidesPerView={1}
                pagination={{ clickable: true }}
                loop
                navigation
                autoplay
            >
                {slides.map((slide, index) => (
                    <SwiperSlide key={index} className="d-flex align-items-center overflow-hidden">
                        <div
                            className="slide-inner slide-bg-image d-flex align-items-center"
                            style={{ background: `url(${getPayloadMedia(slide.imagen?.url || slide.imagen?.[0]?.url)}) center center no-repeat`, backgroundSize: 'cover' }}
                        >
                            <div className="bg-overlay"></div>
                            <Container>
                                <div className="row justify-content-center">
                                    <div className="col-12">
                                        <div className="title-heading text-center">
                                            <h1 className="display-5 text-white title-dark fw-bold mb-4">
                                                {slide.titulo}
                                            </h1>
                                            {slide.subtitulo && (
                                                <p className="para-desc mx-auto text-white">
                                                    {parseHtml(slide.subtitulo)}
                                                </p>
                                            )}

                                            {slide.botonTexto && (
                                                <div className="mt-4 pt-2">
                                                    {/* Si el URL empieza con #, usar ScrollLink para scroll suave */}
                                                    {slide.botonUrl && slide.botonUrl.startsWith('#') ? (
                                                        <ScrollLink
                                                            to={slide.botonUrl.substring(1)} // Remover el #
                                                            spy={true}
                                                            smooth={true}
                                                            duration={500}
                                                            className="btn btn-primary"
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            {slide.botonTexto}
                                                        </ScrollLink>
                                                    ) : (
                                                        <RouterLink to={slide.botonUrl || "#"} className="btn btn-primary">
                                                            {slide.botonTexto}
                                                        </RouterLink>
                                                    )}
                                                </div>
                                            )}
                                          
                                        </div>
                                    </div>
                                </div>
                            </Container>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
}
